import React, { useEffect, useState } from 'react';
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { styledTextarea } from "./styles";
import { NavLink } from "react-router-dom";
import Preloader from "../common/Preloader/Preloader";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../css/themeButtons";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Modal from "../common/Modals/Modal";
import Typography from "@material-ui/core/Typography";


const btnItem = {
  "A": { text: "Подтвердить", btn: "btnGreen" },
  "F": { text: "Незаезд", btn: "btnDanger" },
  "C": { text: "Отказать", btn: "btnWarn" },
  "RT": { text: "Отменить", btn: "btnWarn" },
}

const BookingDetail = (props) => {
  const { booking, getBooking, setBookingStatus } = props;
  const bookingId = props.match.params.bookingId

  const [show, setShow] = useState(false)
  const [newStatusBooking, setNewStatusBooking] = useState()
  const toggleShow = (status) => {
    setNewStatusBooking(status)
    setShow(!show)
  }

  let activityBtn = booking && booking.actions && Object.keys(booking.actions).filter(item => booking.actions[item])

  const reasonBooking = Yup.object().shape({
    reason: Yup.string()
      .matches(/\S/, 'Поле не заполнено')
      .required('Поле не заполнено'),
  })

  useEffect(() => {
    if (bookingId) {
      getBooking(bookingId);
    }
  }, [getBooking, bookingId]);


  const updBookingStatus = (newStatus) => {
    setBookingStatus({ orderId: booking.orderId, status: newStatus })

  }


  const onSubmit = (value) => {
    setBookingStatus({ orderId: booking.orderId, status: newStatusBooking, reason: value.reason })
    toggleShow()
  }


  const buttons = themeButtons()
  if (Object.keys(booking).length === 0) {
    return <Preloader loading={true} text={"Загружаем бронирование"}/>
  }
  return (
    <div className="main">
      <div className="container-fluid">
        <h4>Бронирование №{bookingId}</h4>
        {booking.price ? <p
          className={`${booking.status.type ? `bg-${booking.status.type}` : ""} badge fs-6 text-wrap mb-2`}>{booking.status.name}</p> : null}


        <div className="reservation">


          <div className="row">
            <div className="col-md-6">
              <div className="info">
                <div className="info__title">Информация о госте:</div>
                <div className="info__text">
                  <span>ФИО:</span> {booking.userFullName}</div>
                <div className="info__text">
                  <span>Телефон:</span> {booking.userPhone ? booking.userPhone : '********'}
                </div>
                <div className="info__text">
                  <span>Почта:</span> {booking.userEmail ? booking.userEmail : '********'}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info">
                <div className="info__title">Вопрос от гостя:</div>
                <MuiThemeProvider theme={styledTextarea}>
                  <TextField
                    className="mb-2 w-100"
                    multiline
                    rows={4}
                    defaultValue={booking.question || "Гость не добавил вопрос"}
                    variant="outlined"
                    disabled={true}

                  />
                </MuiThemeProvider>
              </div>
            </div>
          </div>
          <div className="row">
            {booking.hideContacts ? (
              <div className="col-12 mb-3">
                <Alert icon={false} severity="warning">
                  Контакты доступны только для подтверждённых заявок
                </Alert>
              </div>
            ) : null}
          </div>
          {activityBtn.length !== 0 && <div className="action-panel mb-3">
            {activityBtn.map(btn => <Button key={btn}
                                            onClick={() => (btn === "C" || btn === "RT") ? toggleShow(btn) : updBookingStatus(btn)}
                                            className={`btn ${buttons[btnItem[btn].btn]}`}>{btnItem[btn].text}</Button>
            )}

          </div>}


          <div className="info info-pricing">
            <div className="row mb-2">
              <div className="col">
                <div>
                  <span>Дата бронирования:</span>
                </div>
                <div>
                  {booking.dateCreate}
                </div>

              </div>
              <div className="col">
                <div>
                  <span>Количество ночей:</span>

                </div>
                <div>
                  {booking.nights}

                </div>
              </div>

            </div>
            <div className="row mb-2">
              <div className="col">
                <div>
                  <span>Дата заезда:</span>

                </div>
                <div>
                  {booking.dateFrom}
                </div>
              </div>
              <div className="col">
                <div>
                  <span>Дата выезда:</span>
                </div>
                <div>
                  {booking.dateTo}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col">
                <div>
                  <span>Объект размещения:</span>
                </div>
                <div>
                  <Link component={NavLink} to={`/lk/${booking.objectId}`}>{booking.name}</Link>
                </div>
              </div>
              <div className="col">
                <div>
                  <span>Номер:</span>
                </div>
                <div>
                  <Link component={NavLink}
                        to={`/lk/${booking.objectId}/rooms/${booking.room.roomId}`}>{booking.room.name}</Link>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col">

                <div>
                  <span>Адрес объекта размещения:</span>
                </div>
                <div>
                  {booking.address}
                </div>
              </div>
              {booking.price ? <div className="col">
                <div>
                  <span>Тариф:</span>
                </div>
                <div>
                  <span className="badge bg-success">{booking.ratePlan}</span>

                </div>
              </div> : null}
            </div>
            <div className="row mb-2">
              <div className="col">
                <div>
                  <span>Количество человек:</span>
                </div>
                <div>
                  {booking.totalCount} {booking.totalCountDetails}
                </div>
              </div>
              {booking.price ? <div className="col">
                <div>
                  <span>Комиссия сайта:</span>
                </div>
                <div>
                  {booking.commission}₽
                </div>
              </div> : null}

            </div>

            {booking.price ? <div className="row">
              <div className="col">
                <div className="full-price">
                  Сумма бронирования: {booking.price ? booking.price : '0'}₽
                </div>
              </div>

            </div> : null}


          </div>

        </div>

      </div>

      <Formik onSubmit={onSubmit}
              validationSchema={reasonBooking}
              initialValues={{ reason: '' }}>
        {({ handleSubmit, errors, touched, values }) => (
          <Form>
            <Modal toggleShow={toggleShow} btnOkAction={handleSubmit} show={show}
                   title={"Укажите причину отказа:"}
                   textBtnOk={"Отправить"}>
              <Field name="reason">
                {({ field }) =>
                  <TextField
                    {...field}
                    className="mb-2 w-100"
                    multiline
                    rows={4}
                    label={"Причина отказа *"}
                    variant="outlined"
                    error={errors.reason}
                    helperText={errors.reason}
                  />
                }

              </Field>

              <Typography variant="body2" display="block" color="error">
                * - Обязательные поля
              </Typography>

            </Modal>

          </Form>
        )}
      </Formik>

    </div>
  )
}


export default BookingDetail;
